"use client";

/**
 * DescriptionMarkdown — renders proposal description as safe markdown.
 *
 * Supports bulleted lists, bold, italic. No raw HTML (sanitized via dangerouslySetInnerHTML avoided).
 * Uses simple line-by-line rendering for now — upgrade to react-markdown if needed.
 *
 * Text direction is inherited from the global app shell.
 */

interface DescriptionMarkdownProps {
  text: string;
}

export function DescriptionMarkdown({ text }: DescriptionMarkdownProps) {
  const lines = text.split("\n");

  return (
    <div className="text-sm text-text-primary leading-7 whitespace-pre-wrap">
      {lines.map((line, i) => {
        const key = `line-${i}`;
        if (line.startsWith("- ") || line.startsWith("• ")) {
          return (
            <div key={key} className="flex gap-2">
              <span className="text-text-secondary shrink-0">•</span>
              <span>{line.slice(2)}</span>
            </div>
          );
        }
        return <p key={key}>{line || "\u00A0"}</p>;
      })}
    </div>
  );
}
